import { useState } from 'react';
import { ReportApi } from '../../../apis/report-api';

const usePowerBiToken = () => {
  const [token, setToken] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const tokenCallback = (t: any, callback: Function) => {
    setToken(t);
    callback(t);
  }

  const useInitializeToken = (callback: Function) => {
    if (!token) {
      setIsLoading(true);
      setIsError(false);
      ReportApi.getReportAuthToken()
        .then((res) => 
          tokenCallback(res, callback)
        )
        .catch((error) => {
          setIsError(true);
          console.log('Error handling PowerBI Report token: ', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } 
  };

  return { token, isLoading, isError, useInitializeToken };
};

export default usePowerBiToken;
